/**
 * Maneja la actualización de un item en el carrito de compras
 * @param {Object} item - El item a actualizar
 * @param {Function} askUpdateCarItem - Función para abrir el modal de actualización
 * @param {Function} updateCartItem - Función del contexto para actualizar el carrito
 */
export async function handleUpdateCartItem(item, askUpdateCarItem, updateCartItem) {
    try {
        const newData = await askUpdateCarItem(item.buy_value, item.amount, 'amount', item.name);
        if (newData) {
            updateCartItem(item.auxsku, 'buy_value', parseFloat(newData.value));
            updateCartItem(item.auxsku, 'amount', parseFloat(newData.amount));
            return true;
        }
    } catch (e) {
        // El usuario canceló o hubo un error en el prompt
        console.error('Error updating cart item:', e);
    }
    return false;
}
